/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { B2BCompositionGroupDto } from './compositionGroupDto';


export interface B2BCompositionDto { 
    id?: number;
    name?: string | null;
    priority?: number;
    compositionGroups?: Array<B2BCompositionGroupDto> | null;
}

